"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerSource = void 0;
var _react = _interopRequireDefault(require("react"));
var _PropTypes = require("./PropTypes");
var _Banner = require("../Banner");
var _propTypes = require("prop-types");
var BannerSource = exports.BannerSource = function BannerSource(_ref) {
  var _source$value;
  var source = _ref.source,
    layer = _ref.layer,
    cameraPresenterLayersCount = _ref.cameraPresenterLayersCount;
  var _ref2 = layer || {},
    style = _ref2.style;
  var _ref3 = style || {},
    _ref3$bannerStyle = _ref3.bannerStyle,
    bannerStyle = _ref3$bannerStyle === void 0 ? {} : _ref3$bannerStyle,
    _ref3$titleStyle = _ref3.titleStyle,
    titleStyle = _ref3$titleStyle === void 0 ? {} : _ref3$titleStyle,
    _ref3$subTitleStyle = _ref3.subTitleStyle,
    subTitleStyle = _ref3$subTitleStyle === void 0 ? {} : _ref3$subTitleStyle,
    _ref3$animation = _ref3.animation,
    animation = _ref3$animation === void 0 ? {} : _ref3$animation;
  var bannerMarkup = source.value.markup;
  return /*#__PURE__*/_react["default"].createElement(_Banner.Banner, {
    cameraPresenterId: (source === null || source === void 0 || (_source$value = source.value) === null || _source$value === void 0 || (_source$value = _source$value.templateVars) === null || _source$value === void 0 ? void 0 : _source$value.LINE_3) || '',
    bannerStyle: bannerStyle,
    titleStyle: titleStyle,
    subTitleStyle: subTitleStyle,
    animation: animation
  }, bannerMarkup);
};
BannerSource.propTypes = {
  source: _PropTypes.Source,
  style: _PropTypes.Layer,
  cameraPresenterLayersCount: _propTypes.number
};